import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ChoiceGroup } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LocationTargetsEditor } from '@bingads-webui-react/bing-maps';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getLocationTargetingStyles } from './styles/location-targeting-style';
import { targetOptions, getLocationOptionsMap } from './utils/target-options';
import { SectionShimmer } from './utils/shimmer-element';

export function LocationTargetingSelection(props) {
  const {
    selectedLocationOption,
    onChangeLocationOption,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateErrorMessage,
    optionsConfig,
    isLoading,
    ...targetEditorProps
  } = props;

  const { strings } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getLocationTargetingStyles);

  const locationTargetingTitle = useMemo(() => (
    strings.locationTargetingTitle
      ? strings.locationTargetingTitle
      : i18n.getString(_TL_('Where do you want your ads to appear?'))
  ), [i18n, strings]);

  const choiceGroupOptions = useMemo(() => {
    const locationOptionsMap = getLocationOptionsMap(i18n);

    return optionsConfig.map((option) => {
      if (typeof option === 'object') {
        return {
          ...locationOptionsMap[option.key],
          ...option,
        };
      }

      return locationOptionsMap[option];
    });
  }, [i18n, optionsConfig]);

  return (
    <div className="location-target">
      <div className={classNames('location-target-options', classes.locationTargetOptions)}>
        {
          isLoading
            ? <SectionShimmer />
            : (
              <ChoiceGroup
                label={locationTargetingTitle}
                options={choiceGroupOptions}
                selectedKey={selectedLocationOption}
                onChange={(e, option) => onChangeLocationOption(option.key)}
              />
            )
        }
      </div>
      {
          !isLoading && selectedLocationOption === targetOptions.specific
           && <LocationTargetsEditor {...targetEditorProps} />
      }
    </div>
  );
}

LocationTargetingSelection.propTypes = {
  selectedLocationOption: PropTypes.string.isRequired,
  onChangeLocationOption: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    locationTargetingTitle: PropTypes.string,
  }),
  updateErrorMessage: PropTypes.func.isRequired,
  /**
   * Pass in the needed options. The element in array can be either a string or an object.
   */
  optionsConfig: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ])).isRequired,
  isLoading: PropTypes.bool,
};

LocationTargetingSelection.defaultProps = {
  strings: {},
  isLoading: false,
};
